import React, { useState, useEffect } from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image"
// import Slider from "react-slick";
import spotLightMouseArrow from "../../common/images/Homepage/spotlight/spotLightArrow.svg";
// import { Link } from "gatsby";
import alajSaudiArabia from "../../common/images/Homepage/spotlight/alj-saudi-arabia.mp4";
// import { LazyImage } from 'react-lazy-media'
import SiteTrans from "../../components/LangConfig/siteTrans.json";
const SpotlightDetail = (spotlightDetailProps) => {




  const [autoplay, SetAutoPlay] = useState(true)

  const handleResize = () => {
    if (typeof window != 'undefined') {
      if (window.innerWidth <= 767.98) {
        SetAutoPlay(false)
      }
      else {
        SetAutoPlay(true)
      }
    } else {
      SetAutoPlay(true)
    }

  }
  useEffect(() => {
    handleResize()
  })
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  })

  return (
    <>
      <div className="spotlight-detail-wrapper position-relative">

        <div className="d-flex flex-column position-relative">
          <div className="spotlight-detail-banner-container position-relative">
            {/* Image */}
            {/* {console.log(spotlightDetailProps.image,'image')} */}
            {spotlightDetailProps.spotlightDetail.spotlightImageOrSpotlightVideo === "image" ?
              <GatsbyImage className="spotlight-detail-banner" image={getImage(spotlightDetailProps.image)} alt={spotlightDetailProps.image ? spotlightDetailProps.image.altText : "Jameel Motors"} />
              :
              <video
                loading="lazy"
                preload="auto"
                muted
                autoPlay={autoplay}
                loop
                src={spotlightDetailProps.spotlightDetail.spotlightVideo ? spotlightDetailProps.spotlightDetail.spotlightVideo.mediaItemUrl : alajSaudiArabia}
                poster={spotlightDetailProps.image?.sourceUrl} //thumbnail image
                className="spotlight-video"
              ></video>
            }
            <div className="bg-gradient"></div>
          </div>
          <div
            className="spotlight-detail-contents-wrapper position-absolute d-flex flex-column align-items-start"
          >
            <div className="container">
              <h1 className="spotlight-title banner-heading">
                {spotlightDetailProps.title}
              </h1>
              <p className="spotlight-title mb-0 mb-lg-2 font-md"> {spotlightDetailProps.position}</p>
              <p className="spotlight-title font-md"> {spotlightDetailProps.company}</p>
              <div id="spotlight-detail-title-ref" className="spotlight-detail-ref"></div>
              {spotlightDetailProps.description !== "" && (
                <h4 className="spotlight-description font-md mt-0 mt-lg-2">
                  {spotlightDetailProps.description}
                </h4>
              )}
            </div>
          </div>
        </div>
        <div className="explore-label-arrow-container d-flex flex-column align-items-center position-absolute">
          {spotlightDetailProps.triggerScroll !== "" && (
            <>
              <button
                className="explore-label"
                onClick={spotlightDetailProps.triggerScroll}
              >
                {SiteTrans.explore_txt[spotlightDetailProps.lang]}
              </button>
              <button aria-label="arrow" className="explore-arrow-container" onClick={spotlightDetailProps.triggerScroll}>
                <img
                  src={spotLightMouseArrow}
                  alt=""
                  className="explore-arrow"

                />
              </button>

            </>
          )}

        </div>
        <img
          fetchpriority="high"
          className='spotlight-clip-image position-absolute'
          alt="Jameel Motors"
          src={spotlightDetailProps.clipImage}
        />
      </div>
    </>
  );
};

export default SpotlightDetail;
